import { styled } from '@flex-design-system/stitches-react';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { Primitive } from '@radix-ui/react-primitive';
import { nothing, fadeAnimation, scaleAnimation } from '../../utils/keyframes.mjs';
import { ScrollArea } from '../scroll-area/ScrollArea.mjs';

const StyledOverlay = styled(AlertDialogPrimitive.Overlay, {});
const FOG_HEIGHT = 28;
const StyledViewport = styled(ScrollArea.Viewport_Legacy, {
  minWidth: "328px",
  maxWidth: "340px",
  maxHeight: "90vh",
  px: 24,
  paddingBottom: FOG_HEIGHT
});
const StyledFog = styled(ScrollArea.Fog, {
  height: FOG_HEIGHT
});
const StyledContentPositioner = styled(AlertDialogPrimitive.Overlay, {
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  position: "fixed",
  // modal prop에 따라 radix가 동적으로 pointerEvents를 변경하기 때문에 !important 적용
  pointerEvents: "none !important",
  display: "grid",
  placeItems: "center",
  overflowY: "auto",
  // Overlay와 같은 효과를 줍니다.
  // Content가 애니메이션 되는 시간보다 길어야 합니다.
  // Positioner가 Content의 부모요소이기 때문에 부모가 먼저 닫혀버리면 Content의 closed 애니메이션이 끊어집니다.
  '&[data-state="closed"]': {
    animationDuration: fadeAnimation.duration.close,
    animationName: nothing
  }
});
const StyledContent = styled(AlertDialogPrimitive.Content, {
  "@motion": {
    animationDuration: scaleAnimation.duration.open,
    willChange: "transform, opacity",
    '&[data-state="open"]': {
      animationName: scaleAnimation.show(),
      animationTimingFunction: scaleAnimation.timingFunction
    },
    '&[data-state="closed"]': {
      animationName: scaleAnimation.hide(),
      animationDuration: scaleAnimation.duration.close,
      animationTimingFunction: scaleAnimation.timingFunction
    }
  }
});
const StyledContentInner = styled("div", {
  backgroundColor: "white",
  borderRadius: 16,
  boxShadow: "$dialog",
  textAlign: "center",
  /**
   * ShakingAnimation이 실행될 때 컨텐츠가 좌우로 넘치는 것 방지
   */
  overflow: "hidden"
});
const StyledBody = styled(Primitive.div, {
  paddingTop: 28
});
const StyledDescription = styled(AlertDialogPrimitive.Description, {
  fontSize: 14,
  lineHeight: 1.5,
  color: "$gray",
  fontWeight: 400,
  maxWidth: "100%",
  wordBreak: "keep-all"
});
const StyledTitle = styled(AlertDialogPrimitive.Title, {
  lineHeight: 1.5,
  color: "$grayDark",
  fontWeight: 700,
  fontSize: 19,
  maxWidth: "100%",
  wordBreak: "keep-all"
});
const StyledFooterRoot = styled(Primitive.div, {
  display: "grid",
  gap: 8,
  px: 24,
  paddingBottom: 28,
  variants: {
    orientation: {
      vertical: {
        gridAutoFlow: "row",
        gridAutoColumns: "1fr"
      },
      horizontal: {
        gridAutoFlow: "column",
        gridAutoColumns: "1fr"
      }
    }
  }
});
const StyledPortalContainer = styled(Primitive.div, {
  position: "relative"
});

export { StyledBody, StyledContent, StyledContentInner, StyledContentPositioner, StyledDescription, StyledFog, StyledFooterRoot, StyledOverlay, StyledPortalContainer, StyledTitle, StyledViewport };
//# sourceMappingURL=styled.mjs.map
